import CalendarElement from './Calendar'
import Single from './SingleCalendar'

import './style/css'

const Calendar = Object.assign(CalendarElement, { Single })

export default Calendar
